import script from "./CallSessionThread.vue?vue&type=script&setup=true&lang=js"
export * from "./CallSessionThread.vue?vue&type=script&setup=true&lang=js"

import "./CallSessionThread.vue?vue&type=style&index=0&id=195c2f38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195c2f38"]])

export default __exports__